var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "singleBetSlip" } }, [
    _vm.selection
      ? _c(
          "div",
          {
            staticClass: "bsSelection",
            class: [
              {
                priceUp:
                  _vm.priceUp && !(_vm.isclosed || _vm.issuspended || _vm.isNr),
                priceDown:
                  _vm.priceDown &&
                  !(_vm.isclosed || _vm.issuspended || _vm.isNr),
                isClosed: _vm.isclosed,
                isSuspended: _vm.issuspended,
                isNR: _vm.isNr,
                hcpUp: _vm.hcpUp,
                hcpDown: _vm.hcpDown,
                edit: _vm.currentBetSlipState == 0,
                review: _vm.currentBetSlipState == 1,
                changed:
                  !_vm.isclosed &&
                  !_vm.issuspended &&
                  !_vm.isNr &&
                  (_vm.priceUp || _vm.priceDown || _vm.hcpUp || _vm.hcpDown)
              }
            ]
          },
          [
            _c("div", { staticClass: "selection-data" }, [
              _c("div", { staticClass: "columns" }, [
                _c("div", { staticClass: "column column-left" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btnX",
                      attrs: {
                        disabled: !(
                          _vm.currentBetSlipState < 1 ||
                          _vm.betSlipStatus.State == 4 ||
                          (_vm.currentBetSlipState == 6 &&
                            _vm.betSlipStatus.State == 1)
                        )
                      },
                      on: {
                        click: function($event) {
                          return _vm.cancelDialog()
                        }
                      }
                    },
                    [
                      _c("icon", {
                        attrs: { name: "icon-trash", colorName: "red" }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column column-right" }, [
                  _c("label", { attrs: { for: _vm.id } }, [
                    _c("div", { staticClass: "selection-data" }, [
                      _c("div", { staticClass: "selection-name" }, [
                        _c("span", { staticClass: "name" }, [
                          _vm._v(
                            "\n                      " +
                              _vm._s(_vm.formatSelectionName(_vm.selection)) +
                              "\n                     "
                          ),
                          _vm.selection && _vm.selection.currenthandicap
                            ? _c("span", { staticClass: "currenthandicap" }, [
                                _vm._v(
                                  _vm._s(_vm.formatHandicap(_vm.selection))
                                )
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "selection-price" }, [
                          _c("b", { staticClass: "price" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.formatSelectionPrice(_vm.selection))
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.isclosed || _vm.issuspended || _vm.isNr,
                                  expression: "isclosed || issuspended || isNr"
                                }
                              ],
                              staticClass: "lock"
                            },
                            [
                              _vm.isclosed
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("BetSlip.selection.isClosed")
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.issuspended
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("BetSlip.selection.isSuspended")
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isNr
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("BetSlip.selection.isNr"))
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "market-name" }, [
                        _vm._v(_vm._s(_vm.market.name))
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.changed && _vm.currentBetSlipState < 1
              ? _c(
                  "div",
                  { staticClass: "header-changed msg info" },
                  [
                    _c("icon", {
                      attrs: { name: "icon-information", colorName: "blue" }
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm.priceUp
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("BetSlip.selection.changed.priceUp")
                              )
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.priceDown
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("BetSlip.selection.changed.priceDown")
                              )
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hcpUp
                        ? _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("BetSlip.selection.changed.hcpUp"))
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hcpDown
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("BetSlip.selection.changed.hcpDown")
                              )
                            )
                          ])
                        : _vm._e()
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isGeolocated && _vm.isLoggedIn,
                    expression: "!isGeolocated && isLoggedIn"
                  }
                ],
                staticClass: "betPlacement"
              },
              [
                _vm.geolocationMessage.errorCode
                  ? _c("div", { staticClass: "messages align-center" }, [
                      _c("div", { staticClass: "not-geolocated" }, [
                        _vm.geolocationMessage.errorCode === "verify"
                          ? _c(
                              "div",
                              {
                                key:
                                  _vm.geolocationMessage.errorCode +
                                  "-" +
                                  Math.random()
                              },
                              [
                                _c("p", { staticClass: "pls-wait" }, [
                                  _vm._v(_vm._s(_vm.$t("BetSlip.pleaseWait")))
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "verify" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("BetSlip.VerifyingLocation"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "loader-container" },
                                  [_c("circle-loader")],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.geolocationMessage.errorCode === 999 ||
                        _vm.geolocationMessage.errorCode === 612 ||
                        (_vm.errorMsgLocalStorage === "999" ||
                          _vm.errorMsgLocalStorage === "612")
                          ? _c(
                              "div",
                              {
                                key:
                                  _vm.geolocationMessage.errorCode +
                                  "-" +
                                  Math.random()
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("BetSlip.notLocated." + _vm.state)
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("BetSlip.tryAgain." + _vm.state)
                                    )
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ])
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _vm.currentBetSlipState > 1
              ? _c("div", { staticClass: "betPlacement" }, [
                  _c(
                    "div",
                    {
                      staticClass: "messages",
                      class: {
                        loader:
                          _vm.currentBetSlipState == 2 ||
                          _vm.currentBetSlipState == 3 ||
                          _vm.currentBetSlipState == 4
                      }
                    },
                    [
                      _vm.currentBetSlipState == 3 && _vm.inRefferal
                        ? _c("div", { staticClass: "align-center messages" }, [
                            _c("h3", [
                              _c("span", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t(
                                        "BetSlip.status.acceptable.referred.reOffered"
                                      )
                                    ) +
                                    "\n              "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "msg info",
                                class: { inRefferal: _vm.inRefferal }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "BetSlip.betPlacementStatus.Status.detailed.referred.reOffered"
                                      )
                                    )
                                  )
                                ])
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentBetSlipState == 5
                        ? _c("div", { staticClass: "align-center" }, [
                            _vm.betSlipStatus.State == 4
                              ? _c("div", [
                                  _c("h3", [
                                    !_vm.errorType
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "BetSlip.status.rejected"
                                                )
                                              ) +
                                              "\n                "
                                          )
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "BetSlip.placement.error." +
                                                    _vm.errorType +
                                                    ".result"
                                                )
                                              ) +
                                              "\n                "
                                          )
                                        ])
                                  ]),
                                  _vm._v(" "),
                                  _vm.betPlacementResult.Status.StatusText
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "errorMsg reject-reason"
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.betPlacementResult.Status
                                                  .StatusText
                                              )
                                            }
                                          })
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.betSlipStatus.State == 5
                              ? _c(
                                  "div",
                                  [
                                    _c("h3", [
                                      _vm.inRefferal
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BetSlip.status.waiting.reffer"
                                                )
                                              )
                                            )
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("BetSlip.status.waiting")
                                              )
                                            )
                                          ])
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.betPlacementResult.Status
                                        .detailedStates,
                                      function(reason) {
                                        return _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BetSlip.betPlacementStatus.Status.detailed." +
                                                    reason
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          reason === "reOffered"
                                            ? _c("span", [
                                                _c("strong", [
                                                  _vm._v(
                                                    "$ " +
                                                      _vm._s(
                                                        _vm.betPlacementResult.result.TotalStake.toFixed(
                                                          2
                                                        )
                                                      )
                                                  )
                                                ])
                                              ])
                                            : _vm._e()
                                        ])
                                      }
                                    )
                                  ],
                                  2
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentBetSlipState == 6
                        ? _c("div", { staticClass: "align-center" }, [
                            _vm.betSlipStatus.State == 1
                              ? _c("h3", { staticClass: "Bet-Acceptable" }, [
                                  _vm.betPlacementResult.Status
                                    .detailedStates &&
                                  _vm.betPlacementResult.Status.detailedStates.indexOf(
                                    "reOffered"
                                  ) > -1
                                    ? _c("span", [
                                        _vm.inRefferal
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "BetSlip.status.acceptable.referred.reOffered"
                                                  )
                                                )
                                              )
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "BetSlip.status.acceptable.reOffered"
                                                  )
                                                )
                                              )
                                            ])
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("BetSlip.status.acceptable")
                                          )
                                        )
                                      ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.betSlipStatus.State == 3
                              ? _c("h3", { staticClass: "Bet-Reoffered" }, [
                                  _vm.betPlacementResult.Status
                                    .detailedStates &&
                                  _vm.betPlacementResult.Status.detailedStates.indexOf(
                                    "reOffered"
                                  ) > -1
                                    ? _c("span", [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t(
                                                "BetSlip.status.reoffered.reOffered"
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("BetSlip.status.acceptable")
                                          )
                                        )
                                      ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "msg info",
                                class: { inRefferal: _vm.inRefferal }
                              },
                              _vm._l(
                                _vm.betPlacementResult.Status.detailedStates,
                                function(reason) {
                                  return _c("div", [
                                    _vm.inRefferal
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "BetSlip.betPlacementStatus.Status.detailed.referred." +
                                                  reason
                                              )
                                            )
                                          )
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "BetSlip.betPlacementStatus.Status.detailed." +
                                                  reason
                                              )
                                            )
                                          )
                                        ])
                                  ])
                                }
                              ),
                              0
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentBetSlipState == 7
                        ? _c("div", { staticClass: "align-center" }, [
                            _c("h3", [
                              _vm._v(_vm._s(_vm.$t("BetSlip.status.canceled")))
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentBetSlipState == 8
                        ? _c("div", { staticClass: "align-center" }, [
                            _c("h3", [
                              _vm._v(_vm._s(_vm.$t("BetSlip.status.timedOut")))
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentBetSlipState == 9 || _vm.showError
                        ? _c("div", { staticClass: "align-center" }, [
                            _vm.errorMsg
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "errorMsg",
                                    class: _vm.errorId
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "pd-icon pd-icon-dp-info"
                                    }),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass: "message",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "BetSlip.placement.error." +
                                              _vm.errorId,
                                            {
                                              uiView: this.isOpenedFromWebView
                                                ? "?uiView=true"
                                                : ""
                                            }
                                          )
                                        )
                                      }
                                    })
                                  ]
                                )
                              : _c("div", { staticClass: "errorMsg" }, [
                                  _c("span", {
                                    staticClass: "pd-icon pd-icon-dp-info"
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "message" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("BetSlip.status.error"))
                                    )
                                  ])
                                ]),
                            _vm._v(" "),
                            _vm.errors.OTHER
                              ? _c("div", { staticClass: "errorMsg" }, [
                                  _c("span", {
                                    staticClass: "pd-icon pd-icon-dp-info"
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "message" }, [
                                    _vm._v(_vm._s(_vm.errors.OTHER))
                                  ])
                                ])
                              : _vm._e()
                          ])
                        : _vm._e()
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "stake-line" }, [
              _c(
                "div",
                { staticClass: "stake" },
                [
                  _c("money-input", {
                    attrs: {
                      id: 1,
                      inputType: "stake",
                      placeholder: _vm.placeholder.wager,
                      disabled: _vm.currentBetSlipState >= 1,
                      focus: _vm.focus,
                      perType: _vm.perType,
                      minStake: _vm.minStake,
                      maxStake: _vm.maxStake
                    },
                    on: {
                      dismissError: _vm.dismissError,
                      setFocus: _vm.setFocus,
                      hasError: _vm.hasError,
                      input: _vm.storeInput
                    },
                    model: {
                      value: _vm.stake,
                      callback: function($$v) {
                        _vm.stake = $$v
                      },
                      expression: "stake"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isLoggedIn,
                      expression: "!isLoggedIn"
                    }
                  ]
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn primary-button primary-btn",
                      on: {
                        click: function($event) {
                          return _vm.popLogIn()
                        }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("BetSlip.btn.msg.LogIn")))
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isLoggedIn,
                      expression: "isLoggedIn"
                    }
                  ],
                  staticClass: "buttons"
                },
                [
                  _vm.currentBetSlipState == 0
                    ? _c("span", [
                        !_vm.changed
                          ? _c(
                              "button",
                              {
                                staticClass: "btn primary-button primary-btn",
                                class: _vm.disablePlaceBet(),
                                attrs: { disabled: _vm.disablePlaceBet() },
                                on: {
                                  click: function($event) {
                                    return _vm.initPlaceBet()
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "btn-label" }, [
                                  _c("div", { staticClass: "line1" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t("BetSlip.quick.btn.PlaceBet")
                                        ) +
                                        "\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "line2" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("BetSlip.quick.btn.toWin")
                                        ) + "\n                    "
                                      )
                                    ]),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.winning > 0,
                                            expression: "winning>0"
                                          }
                                        ]
                                      },
                                      [_vm._v(" $" + _vm._s(_vm.winning))]
                                    )
                                  ])
                                ])
                              ]
                            )
                          : _c(
                              "button",
                              {
                                staticClass: "btn btn_blue",
                                on: {
                                  click: function($event) {
                                    return _vm.acceptChanges()
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "btn-label" }, [
                                  _c("div", { staticClass: "line1" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t("BetSlip.quick.btn.Accept")
                                        ) +
                                        "\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  false
                                    ? _c("div", { staticClass: "line2" }, [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("BetSlip.quick.btn.toWin")
                                            ) + "\n                  "
                                          )
                                        ]),
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.winning > 0,
                                                expression: "winning>0"
                                              }
                                            ]
                                          },
                                          [_vm._v(" $" + _vm._s(_vm.winning))]
                                        )
                                      ])
                                    : _vm._e()
                                ])
                              ]
                            )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentBetSlipState == 2 || _vm.currentBetSlipState == 3
                    ? _c(
                        "span",
                        { staticClass: "align-center loader-container" },
                        [
                          _c("circle-loader-with-counter", {
                            attrs: { n: _vm.inRunningDelay }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentBetSlipState == 4
                    ? _c("span", { staticClass: "align-center" }, [
                        _c(
                          "div",
                          { staticClass: "loading dots-loader" },
                          [_c("dots-loader")],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentBetSlipState == 5
                    ? _c("div", { staticClass: "align-center" }, [
                        false && _vm.betSlipStatus.State == 2
                          ? _c("div", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn_blue",
                                  on: {
                                    click: function($event) {
                                      return _vm.dismissBetSlip()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("BetSlip.quick.btn.OK")) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn_blue",
                                  on: {
                                    click: function($event) {
                                      return _vm.hideDialog()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("BetSlip.quick.btn.Close")
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.betSlipStatus.State == 4
                          ? _c("div", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn_blue",
                                  on: {
                                    click: function($event) {
                                      return _vm.dismissBetSlip()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("BetSlip.quick.btn.TryAgain")
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        false && _vm.betSlipStatus.State == 5
                          ? _c("div", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn_blue",
                                  on: {
                                    click: function($event) {
                                      return _vm.rejectBetSlip()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("BetSlip.quick.btn.CancelBet")
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.betSlipStatus.State == 5
                          ? _c("div", [
                              _c(
                                "div",
                                { staticClass: "loading dots-loader" },
                                [_c("dots-loader")],
                                1
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentBetSlipState == 6
                    ? _c(
                        "div",
                        {
                          staticClass: "align-center",
                          class: { inRefferal: _vm.inRefferal }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn_white confirm-btn",
                              on: {
                                click: function($event) {
                                  return _vm.confirmBetSlip()
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "btn-label" }, [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.gracePeriod,
                                        expression: "gracePeriod"
                                      }
                                    ],
                                    staticClass:
                                      "loader-container loader_in_btn"
                                  },
                                  [
                                    _c("circle-loader-with-counter", {
                                      attrs: { n: _vm.gracePeriod }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "line1" }, [
                                  _vm.inRefferal
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "BetSlip.placement.btn.CONFIRM.reffer"
                                            )
                                          )
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "BetSlip.quick.btn.ConfirmBet"
                                            )
                                          )
                                        )
                                      ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "line2" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("BetSlip.quick.btn.toWin"))
                                    )
                                  ]),
                                  _vm._v(
                                    " $" +
                                      _vm._s(_vm.winning) +
                                      "\n                "
                                  )
                                ])
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          false
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn_blue",
                                  on: {
                                    click: function($event) {
                                      return _vm.rejectBetSlip()
                                    }
                                  }
                                },
                                [
                                  _vm.inRefferal
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "BetSlip.placement.btn.CANCEL.reffer"
                                            )
                                          )
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "BetSlip.quick.btn.CancelBet"
                                            )
                                          )
                                        )
                                      ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentBetSlipState == 7
                    ? _c("div", { staticClass: "align-center" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn_blue",
                            on: {
                              click: function($event) {
                                return _vm.dismissBetSlip()
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("BetSlip.quick.btn.OK")))
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentBetSlipState == 8
                    ? _c("div", { staticClass: "align-center" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn_blue",
                            on: {
                              click: function($event) {
                                return _vm.dismissBetSlip()
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("BetSlip.quick.btn.OK")))
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentBetSlipState == 9
                    ? _c("div", { staticClass: "align-center" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn_blue",
                            on: {
                              click: function($event) {
                                return _vm.dismissBetSlip()
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("BetSlip.quick.btn.OK")))
                            ])
                          ]
                        )
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _vm.hasErrors
                ? _c(
                    "div",
                    { staticClass: "error-msg" },
                    [
                      _c("span", { staticClass: "pd-icon pd-icon-dp-info" }),
                      _vm._v(" "),
                      _vm._l(_vm.stakeErrors, function(e) {
                        return _c("span", [
                          e
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("BetSlip.stakeNreturn.error." + e, {
                                      min: _vm.minStake,
                                      max: _vm.maxStake
                                    })
                                  )
                                )
                              ])
                            : _vm._e()
                        ])
                      })
                    ],
                    2
                  )
                : _vm._e()
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    false && _vm.currentBetSlipState > 1
      ? _c("div", { staticClass: "betPlacement" }, [
          false &&
          (_vm.currentBetSlipState == 5 || _vm.currentBetSlipState == 6) &&
          _vm.betPlacementResult &&
          _vm.betSlipStatus.State != 4
            ? _c(
                "div",
                { attrs: { id: "betSlipReceipt" } },
                [
                  _vm.betSlipStatus.State === 2
                    ? _c("div", [
                        _vm._v(
                          "\n          Ref: " +
                            _vm._s(_vm.betPlacementResult.ExternalReference)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n          IDFOBetSlip: " +
                            _vm._s(_vm.betPlacementResult.IDFOBetSlip)
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c("hr")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.betPlacementResult.Bets, function(bet) {
                    return _c("div", { staticClass: "Bet" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("BetSlip.betType.REGULAR." + bet.IDFOBetType)
                          )
                        )
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _vm.betPlacementResult.Bets.length > 1
                        ? _c("div", [
                            _vm._v(
                              "\n            TotalStake: $" +
                                _vm._s(bet.TotalStake)
                            ),
                            _c("br"),
                            _vm._v(
                              "\n            Potential Return: $" +
                                _vm._s(
                                  (
                                    bet.PotentialReturn - bet.TotalStake
                                  ).toFixed(2)
                                )
                            ),
                            _c("br"),
                            _vm._v(" "),
                            _c("hr")
                          ])
                        : _vm._e()
                    ])
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "totals" }, [
                    _vm._v(
                      "\n          TotalStake: $" +
                        _vm._s(_vm.betPlacementResult.TotalStake)
                    ),
                    _c("br"),
                    _vm._v(
                      "\n          Potential Return: $" +
                        _vm._s(_vm.attemptedBetPotentialReturn)
                    ),
                    _c("br")
                  ])
                ],
                2
              )
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3aee4fab", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3aee4fab","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslip/SingleBetSlip.vue
// module id = null
// module chunks = 